const ProtectionElements = {
  REGULATORY_SIGNOFF_INPROGRESS: 'protocol.setup.regulatory.signoff.inprogress',// edit mode and view and interact with the Submit icon in the In Progress signoff section.
  REGULATORY_SIGNOFF_ADDITIONAL_REMINDER: 'protocol.setup.regulatory.signoff.additional.reminder',// can view and interact with the Send Reminder icon in the Additional Sign Off(s) signoff section.
  REGULATORY_SIGNOFF_ADDITIONAL: 'protocol.setup.regulatory.signoff.additional',// view and interact with the Submit icon in the Additional Sign Off(s) signoff section.
  REGULATORY_SIGNOFF_SUBMITTED: 'protocol.setup.regulatory.signoff.submitted',// edit mode in the Additional Sign Off(s) signoff section.
  OPEN_SIGNOFF_COMPLETE: 'protocol.setup.open.signoff.complete',// edit mode and view and interact with the Submit icon in the Submitted signoff section.
  OPEN_SIGNOFF_PENDINGSIGNOFF_IROC: 'protocol.setup.open.signoff.pendingsignoff.iroc',// enter edit mode and view and interact with the Save icon in the Completed signoff section.
  OPEN_SIGNOFF_PENDINGSIGNOFF_CTSU: 'protocol.setup.open.signoff.pendingsignoff.ctsu',// edit mode for the OPEN Admin section and view and interact with the Save, Submit, and Send Reminder icons in the Pending Sign Off signoff section.
  OPEN_SIGNOFF_PENDINGSIGNOFF_GROUP: 'protocol.setup.open.signoff.pendingsignoff.group',// enter edit mode for the Group Admin section and view and interact with the Submit, Save, and Save & Send Update icons in the Pending Sign Off signoff section.
  OPEN_SIGNOFF_CTSUTESTING: 'protocol.setup.open.signoff.ctsutesting',// edit mode and view and interact with the Submit icon in the CTSU Testing signoff section.
  OPEN_SIGNOFF_GROUPTESTING_REMINDER: 'protocol.setup.open.signoff.grouptesting.reminder',// view and interact with the Send Reminder icon in the Group Testing signoff section.
  OPEN_SIGNOFF_GROUPTESTING: 'protocol.setup.open.signoff.grouptesting',// edit mode in the Group Testing signoff section view and interact with the Submit icon in the Group Testing signoff section.
  OPEN_SIGNOFF_UATSETUP: 'protocol.setup.open.signoff.uatsetup',// edit mode and view and interact with the Submit icon in the UAT Setup signoff section.
  OPEN_SIGNOFF_SUBMITTED: 'protocol.setup.open.signoff.submitted',// edit mode and view and interact with the Submit icon in the Submitted signoff.

  /**
   * view and interact with the  Regulatory (Part 2)for the user's rostered group(s)
      view and interact with the View History icon and modal
      view and interact with the Delete icon and modal
      view and interact with the + Request icon and modal
      view and interact with the Submit Request icon
      view and interact with the View OPEN/Rave icon
      view and interact with the Save icon
      view and interact with the Clear Changes icon
      view and interact with the Cancel Request icon
   */
  REGULATORY_REQUEST: 'protocol.setup.regulatory.request',

  /**
   * view and interact with the  OPEN/Rave for the user's rostered group(s)
      view and interact with the View History icon and modal
      view and interact with the Delete icon and modal
      view and interact with the + Request icon and modal
      view and interact with the Submit Request icon
      view and interact with the View Regulatory icon
      view and interact with the Save icon
      view and interact with the Clear Changes icon
      view and interact with the Cancel Request icon
   */
  OPEN_REQUEST: 'protocol.setup.open.request',

  /**
   * view the signoff sections for OPEN/Rave-type requests for the user's rostered group(s)
   * view the signoff sections for Regulatory-type requests for the user's rostered group(s)
   */
  SIGNOFF_VIEW: 'protocol.setup.signoff.view',

  /**
  * view the Regulatory (Part 2) for the user's rostered group(s)
    view and interact with the View History icon and modal
    view and interact with the View OPEN/Rave icon
 */
  REGULATORY_VIEW: 'protocol.setup.regulatory.view',

  /**
   * view the OPEN/Rave  for the user's rostered group(s)
    view and interact with the View History icon and modal
    view and interact with the View Regulatory icon
   */

  OPEN_VIEW: 'protocol.setup.open.view',

  /**
   *  view and interact with the Protocol Setup Browser for the user's rostered group(s)
      add /view and interact with the + New Protocol Setup button.
   */

  BROWSER_ADD: 'protocol.setup.browser.add',
  BROWSER: 'protocol.setup.browser',// view and interact with the Protocol Setup Browser for the user's rostered group(s)
  IMPERSONATE: 'protocol.setup.impersonate'// view the Impersonate function within Protocol Setup.
};

export default ProtectionElements;

export const RolesMap = {
  CTMS_REGISTRAR: "CTMS Registrar",
  LPO_REGISTRAR: "LPO Registrar"
}